import Svg, { Path } from 'react-native-svg';
import { withDefaultIconProps } from './index';

export const GeoPin = withDefaultIconProps(
  {
    height: 28,
    width: 28,
  },
  ({ color, ...rest }) => (
    <Svg {...rest} viewBox="0 0 28 28">
      <Path
        d="M21.72 6.77C20.82 5.86 19.76 5.16 18.58 4.68C17.44 4.22 16.23 3.99 15 3.99C13.77 3.99 12.56 4.22 11.42 4.68C10.24 5.16 9.18 5.86 8.28 6.77L8.21 6.84C7.3 7.75 6.6 8.81 6.12 9.99C5.66 11.13 5.42 12.33 5.42 13.56C5.42 14.8 5.66 16 6.12 17.14C6.6 18.32 7.3 19.38 8.21 20.29L13.56 25.64C13.94 26.02 14.45 26.23 15 26.23C15.55 26.23 16.06 26.02 16.44 25.64L21.79 20.29C22.7 19.38 23.4 18.32 23.88 17.14C24.34 16 24.58 14.8 24.58 13.56C24.58 12.33 24.34 11.13 23.88 9.99C23.4 8.81 22.7 7.75 21.79 6.84L21.72 6.77ZM20.71 19.21L15.36 24.56C15.27 24.65 15.14 24.71 15 24.71C14.86 24.71 14.73 24.65 14.64 24.56L9.29 19.21C7.78 17.7 6.95 15.7 6.95 13.56C6.95 11.43 7.78 9.43 9.29 7.92L9.36 7.85C10.86 6.34 12.87 5.51 15 5.51C17.13 5.51 19.14 6.34 20.64 7.85L20.71 7.92C22.22 9.43 23.05 11.43 23.05 13.56C23.05 15.7 22.22 17.7 20.71 19.21Z"
        fill={color}
      />
      <Path
        d="M15 7.6C13.41 7.6 11.91 8.22 10.78 9.35C9.66 10.47 9.04 11.97 9.04 13.56C9.04 15.16 9.66 16.65 10.78 17.78C11.91 18.91 13.41 19.53 15 19.53C16.59 19.53 18.09 18.91 19.22 17.78C20.34 16.65 20.96 15.16 20.96 13.56C20.96 11.97 20.34 10.47 19.22 9.35C18.09 8.22 16.59 7.6 15 7.6ZM18.14 16.7C16.41 18.43 13.59 18.43 11.86 16.7C11.03 15.86 10.57 14.75 10.57 13.56C10.57 12.38 11.03 11.27 11.86 10.43C12.73 9.56 13.86 9.13 15 9.13C16.14 9.13 17.27 9.56 18.14 10.43C18.97 11.27 19.43 12.38 19.43 13.56C19.43 14.75 18.97 15.86 18.14 16.7Z"
        fill={color}
      />
    </Svg>
  ),
);
